import { ButtonBase } from "@repo/ui/index.tsx";
import { useEffect, useState } from "react";
import useJourneyRequests from "../../hooks/useJourneyRequests";
import { useIPBBStore } from "@repo/store";
function TraceIdComp() {
  const [copyText, setCopyText] = useState(false);
  const {
    enquiryData,
    services: { enquiryService },
  } = useJourneyRequests();
  const { ipbbDetails } = useIPBBStore();

  let traceId = enquiryData?.trace_id ?? ipbbDetails?.xutm_token ?? "";
  traceId = traceId + "&&" + (__COMMIT_HASH__ ?? "");

  //EFFECT/s
  useEffect(() => {
    if (copyText) {
      setTimeout(() => {
        setCopyText(false);
      }, 3000);
    }
  }, [copyText]);

  if (!traceId || traceId.trim() === "&&") {
    return <></>;
  }

  if (enquiryService?.isLoading) {
    return (
      <div className="w-48 h-8 bg-extraLightGray animate-pulse rounded-lg" />
    );
  }

  return (
    <ButtonBase
      onClick={() => {
        if (copyText) return;
        navigator.clipboard.writeText(traceId ?? "");
        setCopyText(true);
      }}
      className="px-4 max-sm:px-2 h-8 bg-offWhite gap-1 flex items-center"
      buttonType="tertiary"
      text={
        <p className="flex items-center text-xs font-semibold text-heading">
          <span className="truncate overflow-hidden whitespace-nowrap text-[8px] max-sm:max-w-60">
            {copyText ? "Copied!" : traceId}
          </span>
        </p>
      }
    />
  );
}

export default TraceIdComp;
